import React from 'react';
import { StyleSheet, View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { colors, gradients, radius, spacing } from '../theme/tokens';

export interface BarreSegmentsProps {
  // Étape en cours, à partir de 1 : les segments jusqu'à elle sont remplis.
  etape: number;
  total: number;
  testID?: string;
}

/**
 * Progression d'un parcours en quelques écrans (« 2 sur 3 ») : un segment par écran, rempli du
 * dégradé des appels à l'action jusqu'à l'écran courant. Une seule annonce au lecteur d'écran,
 * comme une jauge ; les segments sont décoratifs.
 */
export function BarreSegments({ etape, total, testID }: BarreSegmentsProps) {
  const courante = Math.max(0, Math.min(total, Math.round(etape)));
  return (
    <View
      testID={testID}
      accessible
      accessibilityRole="progressbar"
      accessibilityValue={{ min: 0, max: total, now: courante }}
      style={styles.barre}
    >
      {Array.from({ length: total }, (_, i) =>
        i < courante ? (
          <LinearGradient
            key={i}
            testID={testID ? `${testID}-segment-${i}` : undefined}
            colors={gradients.cta}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={styles.segment}
          />
        ) : (
          <View
            key={i}
            testID={testID ? `${testID}-segment-${i}` : undefined}
            style={[styles.segment, styles.segmentVide]}
          />
        ),
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  barre: { flexDirection: 'row', gap: spacing.xs + 2 },
  segment: { flex: 1, height: 5, borderRadius: radius.pill },
  segmentVide: { backgroundColor: colors.bordureClaire },
});
